/**
 * Service to handle configuration related API calls
 */

const API_URL = process.env.REACT_APP_API_URL;

const DEFAULT_APP_CONFIG = {
  trialPeriodDays: 3,
  limits: {
    free: {
      messageLimit: 20,
      customCharacterLimit: 1,
      imageRequestLimit: 1,
    },
    paid: {
      messageLimit: null,
      customCharacterLimit: 20,
      imageRequestLimit: 30,
    },
  },
  billing: {
    planName: 'Premium',
    priceId: null,
    amount: 9,
    currency: 'usd',
    interval: 'month',
    intervalCount: 1,
    displayPrice: '$9.00',
    displayInterval: '/month',
    source: 'default',
    isActive: false,
    mode: 'unknown',
  },
};

/**
 * Get application configuration (limits, etc.)
 * @returns {Promise<object>} - App config object
 */
export const getAppConfig = async () => {
  try {
    const response = await fetch(`${API_URL}/utility/app-config`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();

    if (!response.ok) {
      console.warn('Failed to fetch app config, using defaults');
      return DEFAULT_APP_CONFIG;
    }

    return {
      ...DEFAULT_APP_CONFIG,
      ...data.data,
      limits: {
        ...DEFAULT_APP_CONFIG.limits,
        ...(data.data?.limits || {}),
        free: {
          ...DEFAULT_APP_CONFIG.limits.free,
          ...(data.data?.limits?.free || {}),
        },
        paid: {
          ...DEFAULT_APP_CONFIG.limits.paid,
          ...(data.data?.limits?.paid || {}),
        },
      },
      billing: {
        ...DEFAULT_APP_CONFIG.billing,
        ...(data.data?.billing || {}),
      },
    };
  } catch (error) {
    console.error('Error fetching app config:', error);
    // Return defaults on error
    return DEFAULT_APP_CONFIG;
  }
};
